import { Injectable, inject } from "@angular/core";
import { WordPressService } from "./word-press.service";
import { ProductService } from "./product.service";
import { Collection } from "../models/collection";

@Injectable({
  providedIn: "root",
})
export class CollectionService {
  private wpService = inject(WordPressService);
  private productService = inject(ProductService);

  constructor() {}

  async loadCollections(): Promise<Collection[]> {
    const collectionsWP = await this.wpService.getCollections();
    const collections: Collection[] = [];

    for (const collectionWP of collectionsWP) {
      if (!collectionWP) continue;
      if (collectionWP.acf?.homepage) continue;
      // if (!collectionWP.acf?.) continue;
      const productIDs = collectionWP.acf?.product_ids?.split(/\r\n|,/) ?? [];
      // just the fist 3 products
      // if (productIDs.length > 3) {
      //   productIDs.splice(3, productIDs.length - 3);
      // }

      const products = await this.productService.getProducts(productIDs);
      const collection = {
        wpItem: collectionWP,
        products,
      };
      collections.push(collection);
    }

    return collections;
  }

  async loadCollection(collectionName: string): Promise<Collection> {
    const collectionWP = await this.wpService.getCollection(collectionName);

    const collection: Collection = {
      wpItem: collectionWP,
      products: [],
    };

    if (collectionWP.acf?.product_ids) {
      // remove spaces and dashes from isbns
      // then split by newline (\r\n) or comma
      const productIDs = collectionWP.acf.product_ids.split(/\r\n|,/);
      const products = await this.productService.getProducts(productIDs);
      collection.products = products;
    }

    return collection;
  }
}
